import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SLICE_NAME } from './constants';
import { AllEventsContainerState } from './allevents';

const initialState: AllEventsContainerState = {
  scrollPosition: 0,
  page: 0,
};

export const slice = createSlice({
  name: SLICE_NAME,

  initialState,

  reducers: {
    setScrollPosition: (state, action: PayloadAction<number>) => {
      state.scrollPosition = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
  },
});

export const { setScrollPosition, setPage } = slice.actions;

export default slice.reducer;
